<template>
  <a-modal v-model="visible" title="推荐规则设置" @ok="handleOk" @cancel="closeModal(true)" width="600px">
    <div>
      <a-form-model :model="settingForm" :rules="rules" ref="ruleForm">
        <div class="setting-item">
          <div class="setting-lable">体验游戏占比</div>
          <a-form-model-item label="" prop="trialGameRatio">
            <a-input-number placeholder="请输入" v-model="settingForm.trialGameRatio" :precision="0" :min="0" :max="100" />
            <span class="setting-suffix">% 四舍五入</span>
          </a-form-model-item>
        </div>
        <div class="setting-item">
          <div class="setting-lable">最少保留正式游戏</div>
          <a-form-model-item label="" prop="minOfficialGames">
            <a-input-number placeholder="请输入" v-model="settingForm.minOfficialGames" :precision="0" :min="0" :max="9999" />
            <span class="setting-suffix">个/课时</span>
          </a-form-model-item>
        </div>
        <div class="setting-item">
          <div class="setting-lable">最小间隔课时</div>
          <a-form-model-item label="" prop="minIntervalLessons">
            <a-input-number placeholder="请输入" v-model="settingForm.minIntervalLessons" :precision="0" :min="0" :max="9999" />
            <span class="setting-suffix">个课时 同一游戏至少间隔N课时</span>
          </a-form-model-item>
        </div>
      </a-form-model>
      <!-- <div class="body-bottom-tip">每课时约 2 个体验 + 3 个正式。同一游戏间隔 1 课时。下一步选择应用到哪些课程。</div> -->
    </div>

    <a-row slot="footer">
      <a-button @click="closeModal(true)">取消</a-button>
      <a-button type="primary" @click="handleOk">下一步</a-button>
    </a-row>
  </a-modal>
</template>

<script>
export default {
  name: 'SelectExpCourse',
  data() {
    return {
      visible: false,
      settingForm: {
        trialGameRatio: undefined,
        minOfficialGames: undefined,
        minIntervalLessons: undefined,
      },
      rules: {
        trialGameRatio: [{ required: true, message: '请输入内容', trigger: 'blur' }],
        minOfficialGames: [{ required: true, message: '请输入内容', trigger: 'blur' }],
        minIntervalLessons: [{ required: true, message: '请输入内容', trigger: 'blur' }],
      },
    }
  },
  computed: {
    courseSessionCount() {},
  },
  methods: {
    showModal(options = {}) {
      console.log(options)
      return new Promise((resolve, reject) => {
        this._resolve = resolve
        this._reject = reject
        this.visible = true
        if (options.settingForm) {
          this.settingForm = options.settingForm
        }
      })
    },
    closeModal(isReject, params) {
      this.visible = false
      isReject ? this._reject(params) : this._resolve(params)
      this.$nextTick(() => {
        this.settingForm = {
          trialGameRatio: undefined,
          minOfficialGames: undefined,
          minIntervalLessons: undefined,
        }
      })
    },
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.closeModal(false, { ...this.settingForm })
        }
      })
    },
  },
}
</script>
<style>
.setting-lable {
  color: #000;
  font-family: 600;
  margin-bottom: 8px;
}
.setting-item {
  margin-bottom: 20px;
}
.setting-suffix {
  margin-left: 10px;
}
.body-bottom-tip {
  background-color: #e6fff7;
  padding: 12px;
  border-radius: 8px;
  .label {
    color: #000;
    font-family: 600;
  }
}
</style>
